module.exports = __webpack_public_path__ + "media/images/paper_plane-59f742168291c119dc5b81bfb104a847.gif";